import { render, staticRenderFns } from "./day-collection-statistic.vue?vue&type=template&id=48de7aaf&scoped=true"
import script from "./day-collection-statistic.vue?vue&type=script&lang=ts"
export * from "./day-collection-statistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de7aaf",
  null
  
)

export default component.exports